import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const SnookerIcon = observer('SnookerIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                d='M11.9998 8.26854C13.0303 8.26854 13.8109 7.45667 13.8109 6.45745C13.8109 6.17642 13.7485 5.89539 13.6236 5.64559C13.6204 5.64244 13.6138 5.62949 13.6032 5.60874C13.5084 5.42332 13.0951 4.61514 11.9998 4.61514C10.964 4.61514 10.5231 5.35284 10.3862 5.5818C10.3663 5.61511 10.3528 5.63766 10.3449 5.64559C10.22 5.89539 10.1575 6.1452 10.1575 6.42623C10.1575 7.42545 11.0006 8.26854 11.9998 8.26854Z'
                fill='fill'
            />
            <path
                d='M11.6563 10.1733C11.6563 11.1725 10.8757 11.9844 9.84525 11.9844C8.565 11.9844 7.59701 10.6729 8.25275 9.33021V9.29898C8.565 8.73692 9.15829 8.36221 9.84525 8.36221C10.8445 8.36221 11.6563 9.17408 11.6563 10.1733Z'
                fill='fill'
            />
            <path
                d='M12.3121 10.1733C12.3121 11.1725 13.1239 11.9844 14.1232 11.9844C15.1536 11.9844 15.9342 11.1725 15.9342 10.1733C15.9342 9.17408 15.1224 8.36221 14.1232 8.36221C13.1552 8.33099 12.3121 9.17408 12.3121 10.1733Z'
                fill='fill'
            />
            <path
                d='M18.12 13.9204C18.12 14.9206 17.3092 15.7315 16.3089 15.7315C15.3087 15.7315 14.4979 14.9206 14.4979 13.9204C14.4979 12.9201 15.3087 12.1093 16.3089 12.1093C17.3092 12.1093 18.12 12.9201 18.12 13.9204Z'
                fill='fill'
            />
            <path
                d='M11.9999 15.7315C13.0001 15.7315 13.811 14.9206 13.811 13.9204C13.811 12.9201 13.0001 12.1093 11.9999 12.1093C10.9996 12.1093 10.1888 12.9201 10.1888 13.9204C10.1888 14.9206 10.9996 15.7315 11.9999 15.7315Z'
                fill='fill'
            />
            <path
                d='M7.72191 12.1093C8.72113 12.1093 9.533 12.9211 9.533 13.9204C9.533 14.9196 8.72113 15.7315 7.72191 15.7315C6.72269 15.7315 5.91083 14.9196 5.91083 13.9204C5.91083 12.9211 6.72269 12.1093 7.72191 12.1093Z'
                fill='fill'
            />
            <path
                d='M18.4323 19.4473C19.4325 19.4473 20.2434 18.6365 20.2434 17.6362C20.2434 16.636 19.4325 15.8251 18.4323 15.8251C17.4321 15.8251 16.6212 16.636 16.6212 17.6362C16.6212 18.6365 17.4321 19.4473 18.4323 19.4473Z'
                fill='fill'
            />
            <path
                d='M15.9655 17.6362C15.9655 18.6365 15.1546 19.4473 14.1544 19.4473C13.1542 19.4473 12.3433 18.6365 12.3433 17.6362C12.3433 16.636 13.1542 15.8251 14.1544 15.8251C15.1546 15.8251 15.9655 16.636 15.9655 17.6362Z'
                fill='fill'
            />
            <path
                d='M9.84527 15.8251C8.84605 15.8251 8.03418 16.637 8.03418 17.6362C8.03418 18.6354 8.84605 19.4473 9.84527 19.4473C10.8757 19.4473 11.6564 18.6354 11.6564 17.6362C11.6876 16.637 10.8445 15.8251 9.84527 15.8251Z'
                fill='fill'
            />
            <path
                d='M7.37846 17.6362C7.37846 18.6365 6.56761 19.4473 5.56737 19.4473C4.56714 19.4473 3.75629 18.6365 3.75629 17.6362C3.75629 16.636 4.56714 15.8251 5.56737 15.8251C6.56761 15.8251 7.37846 16.636 7.37846 17.6362Z'
                fill='fill'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M21.5549 16.1374L14.8726 4.55269C14.2793 3.52225 13.1864 2.89774 11.9998 2.89774C10.8132 2.89774 9.72035 3.52225 9.12706 4.55269L2.44478 16.1374C1.8515 17.1678 1.8515 18.4169 2.44478 19.4473C3.03807 20.4778 4.09974 21.1023 5.31754 21.1023H18.6821C19.8687 21.1023 20.9616 20.4778 21.5549 19.4473C22.1481 18.3856 22.1481 17.1678 21.5549 16.1374ZM20.7118 18.9477C20.2746 19.6971 19.5252 20.1343 18.6821 20.1343H5.31754C4.47445 20.1343 3.72503 19.6971 3.28787 18.9477C2.85071 18.2295 2.85071 17.324 3.28787 16.6058L9.97015 5.02108C10.4073 4.27166 11.1567 3.8345 11.9998 3.8345C12.8429 3.8345 13.5923 4.27166 14.0295 5.02108L20.7118 16.6058C21.1177 17.324 21.1177 18.1983 20.7118 18.9477Z'
                fill='fill'
            />
        </SvgElement>
    );
});
